import Pill from "../../../../../Pill";
import CategoryHeaderLinks from "../CategoryHeaderLinks";

const TextCategoryHeaderLinks = props => (
  <CategoryHeaderLinks {...props} ItemComponent={Pill} />
);

export default TextCategoryHeaderLinks;
